import React, { useState } from "react";
import useProducers from "../../../../../hooks/useProducers/useProducers";
import useRole from "../../../../../hooks/useRole/useRole";
import useClientFilters from "./useClientFilters";
import { countActiveFilters } from "./clientFilterTokens";
import ClientQuickFilterBar from "./ClientQuickFilterBar";
import ClientActiveFiltersSummary from "./ClientActiveFiltersSummary";
import ClientAdvancedFiltersPanel from "./ClientAdvancedFiltersPanel";
// Design system `.lf-*` des cartouches leads, déjà scopé sous `.lf`.
import "../../../LeadListPage/LeadListFilters/leadFilters.css";
import "./clientFilters.css";

// Cartouche de filtres de la liste des clients : barre repliée + vues rapides,
// ligne de résumé des filtres actifs, tiroir avancé
// (docs/superpowers/specs/2026-10-02-refonte-ux-filtres-clients-design.md).
const ClientFilters = () => {
  const { myRole } = useRole();
  // Les sociétés partenaires servent au tiroir et aux jetons ; un partenaire ne les voit pas.
  useProducers(myRole !== "PARTNER");
  const { filtres, isLoadingClients, actions } = useClientFilters();
  const [showAdvanced, setShowAdvanced] = useState(false);

  const activeFilterCount = countActiveFilters(filtres);

  const onSubmitSearch = (e) => {
    e.preventDefault();
    actions.applyAndSearch({});
  };

  return (
    <form onSubmit={onSubmitSearch} className="lf mb-3">
      <ClientQuickFilterBar
        showAdvanced={showAdvanced}
        onToggleAdvanced={() => setShowAdvanced((v) => !v)}
        activeFilterCount={activeFilterCount}
        isLoading={isLoadingClients}
      />

      <ClientActiveFiltersSummary />

      {showAdvanced && (
        <ClientAdvancedFiltersPanel onClose={() => setShowAdvanced(false)} isLoading={isLoadingClients} />
      )}
    </form>
  );
};

export default ClientFilters;
